import React from 'react'

import '../styles/Games.css'
import { Link } from 'react-router-dom'


export default function Games() {
  return (
      <div className='Games'>
          <h1>Games</h1>
          <div className="Games-container">
            
            <div  className='game'>
              <h3>Re-arrange</h3>
              <p>
                Rearrange the given word. Stuck on a word? Use the hints to get a better idea of what the word could be. 
              </p>
              <Link to='/games/rearrange'>
                Play
              </Link>
            </div>
            <div  className='game'>
              <h3>SimilarTo</h3>
              <p>
                Select the similar word to the given word out of four options.
              </p>
              <Link to='/games/similarto'>
                Play
              </Link>
            </div>
          </div>
      </div>
  )
}
